import moment from 'moment';
import { cacheService } from '../helper/utils';
import { t } from 'i18next';
import { PAGE_CODE } from '../helper/constant';
const pageCode = PAGE_CODE.COMMON_CODE

export const PORTAL_GROUP_SKTES_ADMIN = 'SK TES Admin'
export const isSkAdminGroup = (name) => {
    return (name && name.toLowerCase() === PORTAL_GROUP_SKTES_ADMIN.toLowerCase())
}

export const FAQ_TYPES = {
    VIDEO: 1,
    GENERAL: 2,
    REPORT: 3,
    REQUEST: 4,
    OTHER: 5,
}

export const PORTAL_FORMAT = {
    PHONENUMBER: "###-###-####",

    SHORT_DATE: 'DD/MM/YYYY',
    LONG_DATE: 'DD MMM YYYY',
    FULL_LONG_DATE: 'DD MMMM YYYY',

    SHORT_DATETIME: 'DD/MM/YYYY HH:mm',
    LONG_DATETIME: 'DD MMM YYYY HH:mm',
    FULL_LONG_DATETIME: 'DD MMMM YYYY HH:mm',

    // new format
    FULL_LONG_DATETIME_12H: 'DD MMMM YYYY h:mm a',
    LONG_DATETIME_12H: 'DD MMM YYYY h:mm a',
    SHORT_DATETIME_12H: 'DD/MM/YYYY h:mm a',
    DAY_LONG_DATE: 'dddd, DD MMM YYYY',
    DAY_SHORT_DATE: 'ddd, DD/MM/YYYY',
    DAY_SHORT_DATETIME: 'ddd, DD/MM/YYYY HH:mm',
    DAY_SHORT_DATETIME_12H: 'ddd, DD/MM/YYYY h:mm a',
    DAY_LONG_DATETIME: 'dddd, DD MMM YYYY HH:mm',
    DAY_LONG_DATETIME_12H: 'dddd, DD MMM YYYY h:mm a',

    EMAIL_LOGTIME: 'YYYY-MM-DD h:mm:ss a',
    HTML_TAG_DATE: 'YYYY-MM-DD',

    /***********moment************/
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm'
}
export const fmtDate = (d1) => {
    const date = moment(d1);
    if (!date.isValid()) {
        return "";
    }
    return date.format(PORTAL_FORMAT.SHORT_DATE);
}
export const fmtDateTime = (d1) => {
    const date = moment(d1);
    if (!date.isValid()) {
        return "";
    }
    return date.format(PORTAL_FORMAT.SHORT_DATETIME);
}

export const fmtLongDate = (d1) => {
    const date = moment(d1);
    if (!date.isValid()) {
        return "";
    }
    return date.format(PORTAL_FORMAT.LONG_DATE);
}

export const fmtLongDateTime = (d1) => {
    const date = moment(d1);
    if (!date.isValid()) {
        return "";
    }
    return date.format(PORTAL_FORMAT.LONG_DATETIME);
}
export const fmtDateTag = (d1) => {
    const date = moment(d1);
    if (!date.isValid()) {
        return "";
    }
    return date.format(PORTAL_FORMAT.HTML_TAG_DATE);
}

export const fmtTimeOnly = (d1) => {
    const date = moment(d1);
    if (!date.isValid()) {
        return "";
    }
    return date.format(PORTAL_FORMAT.LTS); 
}

export const setUserFormatConfig = (data) => {
    let dateFormatByUser = PORTAL_FORMAT.SHORT_DATE
    let dateFormatByUserWithHours = PORTAL_FORMAT.SHORT_DATETIME
    let dateFormats = {
        dateFormatByUser,
        dateFormatByUserWithHours,
    }

    let dateFormat = ((data && data.dateFormat) || '').trim()
    if (dateFormat) {
        dateFormatByUser = (dateFormat)
        dateFormatByUserWithHours = ('').concat(dateFormatByUser, " HH:mm")
        //update 
        Object.assign(dateFormats, {
            dateFormatByUser,
            dateFormatByUserWithHours,
        })
        //update global config
        Object.assign(PORTAL_FORMAT, {
            dateFormatByUser,
            dateFormatByUserWithHours,
        })
    }
    cacheService.setCache('dateFormats', dateFormats);
    return { ...dateFormats };
}
export const TYPE_COLORS = [
    "rgb(79,84,103)",
    "rgb(62,191,234)",
    "rgb(245,4,4)",
    "rgb(20,181,1)",
    "rgb(29,233,182)",
    "rgb(163,137,212)",
    "rgb(254,138,125)",
    "rgb(0, 0, 255)",
    "rgb(255, 0, 0)",
    "rgb(255, 165, 0)",
    "rgb(154, 205, 50)",
    "rgb(0, 128, 0)",
    "rgb(128, 0, 128)",
    "rgb(128, 128, 128)",
    "rgb(138, 43, 226)",
    "rgb(165, 42, 42)",
    "rgb(95, 158, 160)",
    "rgb(210, 105, 30)",
    "rgb(0, 139, 139)",
    "rgb(0, 128, 128)",
    "rgb(112, 128, 144)",
    "rgb(210, 180, 140)",
    "rgb(70, 130, 180)",
    "rgb(135, 206, 235)",
    "rgb(102, 51, 153)",
    "rgb(75, 0, 130)",
    "rgb(160, 82, 45)",
    "rgb(238, 130, 238)",
    "rgb(255, 99, 71)",
    "rgb(107, 142, 35)",
    "rgb(128, 128, 0)",
    "rgb(128, 0, 0)",
    "rgb(176, 224, 230)",
    "rgb(205, 133, 63)",
    "rgb(221, 160, 221)",
    "rgb(255, 192, 203)",
    "rgb(240, 248, 255)",
    "rgb(250, 235, 215)",
    "rgb(0, 255, 255)",
    "rgb(127, 255, 212)",
    "rgb(240, 255, 255)",
]

export const getStatusBgColor = (statusName) => {
    const mapStatusColor = {
        New: "primary",
        Pending: "warning",
        Cancel: "danger",
        Completed: "success",
        "Schedule Date": "info",
        "Reached Facility": "dark",
        "Reporting Done": "light",
    }
    return mapStatusColor[statusName] || "secondary"
}

function padZero(str, len) {
    len = len || 2;
    let zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
}
function rNum() {
    return Math.floor(Math.random() * 256);
}
function toHexStr(c) {
    let hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
export function invertColorHex(hex, bw) {
    let color = hexToRgb(hex)
    return color ? invertColorRgb(color, bw) : null
}
export function invertColorRgb(color, bw) {
    let { r, g, b } = color;
    if (bw) {
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186
            ? '#000000'
            : '#FFFFFF';
    }
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    return "#" + padZero(r) + padZero(g) + padZero(b);
}
export function rgbToHex(r, g, b) {
    return "#" + toHexStr(r) + toHexStr(g) + toHexStr(b);
}
export function hexToRgb(hex) {
    let rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return rgb ? {
        r: parseInt(rgb[1], 16),
        g: parseInt(rgb[2], 16),
        b: parseInt(rgb[3], 16)
    } : null;
}
export function rgbToArray(str) {
    let rgb = /^rgba?[\s]*\([\s]*([\d]{1,3})[\s]*,[\s]*([\d]{1,3})[\s]*,[\s]*([\d]{1,3})([\s]*,[\s]*([\d.e]+))?[\s]*\)[\s]*$/i.exec(str);
    return rgb ? [parseInt(rgb[1]), parseInt(rgb[2]), parseInt(rgb[3])] : null;
}
export function invertColorRgbStr(str) {
    let rgb = rgbToArray(str);
    return rgb ? invertColorRgb({ r: rgb[0], g: rgb[1], b: rgb[2] }, true) : null
}
export function randomRGB() {
    let r = rNum();
    let g = rNum();
    let b = rNum();
    return [r, g, b];
}

export const DEFAULT_COLORS = ['blue', 'red', 'orange', 'yellowgreen', 'green', 'purple',
    'grey', 'blueviolet', 'brown', 'cadetblue', 'chocolate',
    'darkcyan', 'teal', 'slategrey', 'tan', 'steelblue',
    'skyblue', 'rebeccapurple', 'indigo', 'sienna', 'violet',
    'tomato', 'olivedrab', 'olive', 'maroon', 'powderblue', 'peru', 'plum', 'pink']

export const BASE_COLORS = {
    "aliceblue": [240, 248, 255],
    "antiquewhite": [250, 235, 215],
    "aqua": [0, 255, 255],
    "aquamarine": [127, 255, 212],
    "azure": [240, 255, 255],
    "beige": [245, 245, 220],
    "bisque": [255, 228, 196],
    "black": [0, 0, 0],
    "blanchedalmond": [255, 235, 205],
    "blue": [0, 0, 255],
    "blueviolet": [138, 43, 226],
    "brown": [165, 42, 42],
    "burlywood": [222, 184, 135],
    "cadetblue": [95, 158, 160],
    "chartreuse": [127, 255, 0],
    "chocolate": [210, 105, 30],
    "coral": [255, 127, 80],
    "cornflowerblue": [100, 149, 237],
    "cornsilk": [255, 248, 220],
    "crimson": [220, 20, 60],
    "cyan": [0, 255, 255],
    "darkblue": [0, 0, 139],
    "darkcyan": [0, 139, 139],
    "darkgoldenrod": [184, 134, 11],
    "darkgray": [169, 169, 169],
    "darkgreen": [0, 100, 0],
    "darkgrey": [169, 169, 169],
    "darkkhaki": [189, 183, 107],
    "darkmagenta": [139, 0, 139],
    "darkolivegreen": [85, 107, 47],
    "darkorange": [255, 140, 0],
    "darkorchid": [153, 50, 204],
    "darkred": [139, 0, 0],
    "darksalmon": [233, 150, 122],
    "darkseagreen": [143, 188, 143],
    "darkslateblue": [72, 61, 139],
    "darkslategray": [47, 79, 79],
    "darkslategrey": [47, 79, 79],
    "darkturquoise": [0, 206, 209],
    "darkviolet": [148, 0, 211],
    "deeppink": [255, 20, 147],
    "deepskyblue": [0, 191, 255],
    "dimgray": [105, 105, 105],
    "dimgrey": [105, 105, 105],
    "dodgerblue": [30, 144, 255],
    "firebrick": [178, 34, 34],
    "floralwhite": [255, 250, 240],
    "forestgreen": [34, 139, 34],
    "fuchsia": [255, 0, 255],
    "gainsboro": [220, 220, 220],
    "ghostwhite": [248, 248, 255],
    "gold": [255, 215, 0],
    "goldenrod": [218, 165, 32],
    "gray": [128, 128, 128],
    "green": [0, 128, 0],
    "greenyellow": [173, 255, 47],
    "grey": [128, 128, 128],
    "honeydew": [240, 255, 240],
    "hotpink": [255, 105, 180],
    "indianred": [205, 92, 92],
    "indigo": [75, 0, 130],
    "ivory": [255, 255, 240],
    "khaki": [240, 230, 140],
    "lavender": [230, 230, 250],
    "lavenderblush": [255, 240, 245],
    "lawngreen": [124, 252, 0],
    "lemonchiffon": [255, 250, 205],
    "lightblue": [173, 216, 230],
    "lightcoral": [240, 128, 128],
    "lightcyan": [224, 255, 255],
    "lightgoldenrodyellow": [250, 250, 210],
    "lightgray": [211, 211, 211],
    "lightgreen": [144, 238, 144],
    "lightgrey": [211, 211, 211],
    "lightpink": [255, 182, 193],
    "lightsalmon": [255, 160, 122],
    "lightseagreen": [32, 178, 170],
    "lightskyblue": [135, 206, 250],
    "lightslategray": [119, 136, 153],
    "lightslategrey": [119, 136, 153],
    "lightsteelblue": [176, 196, 222],
    "lightyellow": [255, 255, 224],
    "lime": [0, 255, 0],
    "limegreen": [50, 205, 50],
    "linen": [250, 240, 230],
    "magenta": [255, 0, 255],
    "maroon": [128, 0, 0],
    "mediumaquamarine": [102, 205, 170],
    "mediumblue": [0, 0, 205],
    "mediumorchid": [186, 85, 211],
    "mediumpurple": [147, 112, 219],
    "mediumseagreen": [60, 179, 113],
    "mediumslateblue": [123, 104, 238],
    "mediumspringgreen": [0, 250, 154],
    "mediumturquoise": [72, 209, 204],
    "mediumvioletred": [199, 21, 133],
    "midnightblue": [25, 25, 112],
    "mintcream": [245, 255, 250],
    "mistyrose": [255, 228, 225],
    "moccasin": [255, 228, 181],
    "navajowhite": [255, 222, 173],
    "navy": [0, 0, 128],
    "oldlace": [253, 245, 230],
    "olive": [128, 128, 0],
    "olivedrab": [107, 142, 35],
    "orange": [255, 165, 0],
    "orangered": [255, 69, 0],
    "orchid": [218, 112, 214],
    "palegoldenrod": [238, 232, 170],
    "palegreen": [152, 251, 152],
    "paleturquoise": [175, 238, 238],
    "palevioletred": [219, 112, 147],
    "papayawhip": [255, 239, 213],
    "peachpuff": [255, 218, 185],
    "peru": [205, 133, 63],
    "pink": [255, 192, 203],
    "plum": [221, 160, 221],
    "powderblue": [176, 224, 230],
    "purple": [128, 0, 128],
    "rebeccapurple": [102, 51, 153],
    "red": [255, 0, 0],
    "rosybrown": [188, 143, 143],
    "royalblue": [65, 105, 225],
    "saddlebrown": [139, 69, 19],
    "salmon": [250, 128, 114],
    "sandybrown": [244, 164, 96],
    "seagreen": [46, 139, 87],
    "seashell": [255, 245, 238],
    "sienna": [160, 82, 45],
    "silver": [192, 192, 192],
    "skyblue": [135, 206, 235],
    "slateblue": [106, 90, 205],
    "slategray": [112, 128, 144],
    "slategrey": [112, 128, 144],
    "snow": [255, 250, 250],
    "springgreen": [0, 255, 127],
    "steelblue": [70, 130, 180],
    "tan": [210, 180, 140],
    "teal": [0, 128, 128],
    "thistle": [216, 191, 216],
    "tomato": [255, 99, 71],
    "turquoise": [64, 224, 208],
    "violet": [238, 130, 238],
    "wheat": [245, 222, 179],
    "white": [255, 255, 255],
    "whitesmoke": [245, 245, 245],
    "yellow": [255, 255, 0],
    "yellowgreen": [154, 205, 50]
}

export const RGB_COLORS = [];

for (let i = 0; i < DEFAULT_COLORS.length; i++) {
    let k = DEFAULT_COLORS[i]
    let c = BASE_COLORS[k]
    let v = `rgb(${c[0]}, ${c[1]}, ${c[2]})`
    DEFAULT_COLORS.splice(i, 1, v)
}

for (let k in BASE_COLORS) {
    let c = BASE_COLORS[k]
    let v = `rgb(${c[0]}, ${c[1]}, ${c[2]})`
    if (!RGB_COLORS.includes(v)) {
        RGB_COLORS.push(v)
    }
}

export const getDefaultColors = (all = true, reverse = false) => {
    let sources1 = [...DEFAULT_COLORS]
    if (all) {
        let sources2 = [...RGB_COLORS].filter(c2 => !sources1.find(c1 => c1 === c2))
        Array.prototype.push.apply(sources1, sources2)
    }
    if (reverse) {
        sources1.reverse()
    }
    return sources1;
}

export const randomColors = (size = 120) => {
    let sources1 = [...DEFAULT_COLORS]
    let sources2 = [...RGB_COLORS].filter(c2 => !sources1.find(c1 => c1 === c2))
    let colors = [];
    let i = 0;
    while (i < size && sources1.length > 0) {
        let r = Math.floor(Math.random() * 16777215) % sources1.length;
        let v = sources1[r]
        if (!colors.includes(v)) {
            colors.push(v)
            sources1.splice(r, 1)
            i++
        }
    }
    while (i < size && sources2.length > 0) {
        let r = Math.floor(Math.random() * 16777215) % sources2.length;
        let v = sources2[r]
        if (!colors.includes(v)) {
            colors.push(v)
            sources2.splice(r, 1)
            i++
        }
    }
    while (i < size) {
        // console.log('randomColors-y', i, size)
        let c = randomRGB()
        let v = (`rgb(${c[0]}, ${c[1]}, ${c[2]})`)
        if (!colors.includes(v)) {
            colors.push(v)
            i++
        }
    }
    return colors;
}

export const bgColors = (rgbColors = [], opacity = 0.7) => {
    // Border colors with 70% transparency
    return rgbColors.map(color => color.replace('rgb(', 'rgba(').replace(')', `, ${opacity})`));
}

export const defaultSelectStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    menu: provided => ({ ...provided, zIndex: 9999, backgroundColor: 'white' }),
    control: (base) => ({
        ...base,
        fontSize: '1rem',
        backgroundColor: 'white',
        display: 'flex',
        height: "2.5rem",
        lineHeight: "1rem",
        borderRadius: 10,
        boxShadow: "none",
        color: "#aaaaaa",
        borderColor: '#cccccc',
        '&:hover': { borderColor: '#cccccc' },
        minWidth: '100px',
    }),
    placeholder: (base, state) => ({
        ...base,
        fontSize: '1rem',
        color: state.selectProps.value?.value ? state.selectProps.value?.value === t(`${pageCode}.LabelSelect`) || state.selectProps.value?.value === t(`${pageCode}.LabelSelectAnOption`) ? "#808080" : "#161616" : "#808080"
    }),
    singleValue: (base, state) => ({
        ...base,
        fontSize: '1rem',
        overflow: 'visible',
        color: state.selectProps.value?.value ? state.selectProps.value?.value === t(`${pageCode}.LabelSelect`) || state.selectProps.value?.value === t(`${pageCode}.LabelSelectAnOption`) ? "#808080" : "#161616" : "#808080"
    }),
    option: (base, state) => ({
        ...base,
        fontSize: '1rem',
        color: '#161616',
        backgroundColor: state.isSelected ? '#F2F7D8' : 'inherit',
        '&:hover': { backgroundColor: state.isSelected ? '#F2F7D8' : '#F2F7D8', color: '#161616' }
    }),
}

export const defaulSelectIndicatorSeparatorStyles = {
    menu: base => ({ ...base, zIndex: 9999 }),
    control: (base) => ({
        ...base,
        fontSize: '1rem',
        background: 'transparent',
        display: 'flex',
        height: "2.5rem",
        borderRadius: '.25rem',
        boxShadow: "none",
        color: "#aaaaaa",
        borderColor: '#cccccc',
        '&:hover': { borderColor: '#cccccc' },
    }),
    indicatorSeparator: () => ({
        display: "none", // Hides the separator between content and dropdown icon
    }),
    placeholder: (base, state) => ({
        ...base,
        fontSize: '1rem',
        color: state.selectProps.value?.value ? "#161616" : "#808080",
    }),
    singleValue: (base, state) => ({
        ...base,
        fontSize: '1rem',
        color: state.selectProps.value?.value ? "#161616" : "#808080",
    }),
    option: (base, state) => ({
        ...base,
        color: '#161616',
        backgroundColor: state.isSelected ? '#F2F7D8' : 'inherit',
        '&:hover': { backgroundColor: state.isSelected ? '#F2F7D8' : '#f2f7d8cc', color: '#161616' }
    }),
    container: (base) => ({
        ...base,
        fontSize: '1rem',
        minWidth: 180,
    }),
    valueContainer: (base) => ({
        ...base,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "flex",
        alignItems: "center",
    })
}

export const MAX_FILE_SIZE = 100;
export const MAX_CHUNK_SIZE = 9.5;
export const CONSIDER_AS_LARGE_FILE = 9 * 1024 * 1024;
export const LIMIT_LARGE_FILE_SIZE = 100 * 1024 * 1024;

// DOCUMENT REPORT STATUS KEYS
export const DOCUMENT_UPLOADED = null
export const DOCUMENT_ADMIN_APPROVED = 1;
export const DOCUMENT_ADMIN_DECLINED = 2;
export const DOCUMENT_WAITING_ADMIN_APPROVED = 3;
export const DOCUMENT_CLIENT_APPROVED = 4;
export const DOCUMENT_CLIENT_DECLINED = 5;
export const DOCUMENT_WAITING_CLIENT_APPROVED = 6;
export const DOCUMENT_AUTO_APPROVED = 7;

export const DOCUMENT_REPORT_STATUS = [
    { value: DOCUMENT_UPLOADED, label: 'Uploaded' },
    { value: DOCUMENT_WAITING_ADMIN_APPROVED, label: 'Waiting for SKTES Approval' }, // only show documents on admin site, hide on client site 
    { value: DOCUMENT_ADMIN_APPROVED, label: 'Admin Approved' }, // show documents on admin and client as well
    { value: DOCUMENT_ADMIN_DECLINED, label: 'Admin Declined' }, // only show documents on admin site, hide on client site
    { value: DOCUMENT_WAITING_CLIENT_APPROVED, label: 'Waiting for Client Approval' },
    { value: DOCUMENT_CLIENT_APPROVED, label: 'Client Approved' },
    { value: DOCUMENT_CLIENT_DECLINED, label: 'Client Declined' },
    { value: DOCUMENT_AUTO_APPROVED, label: 'Auto Approved' },
]
